import { render } from "./ActivationSuccessIcon.vue?vue&type=template&id=2394b5ce&scoped=true&ts=true"
import script from "./ActivationSuccessIcon.vue?vue&type=script&lang=ts"
export * from "./ActivationSuccessIcon.vue?vue&type=script&lang=ts"

import "./ActivationSuccessIcon.vue?vue&type=style&index=0&id=2394b5ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2394b5ce"]])

export default __exports__